import { render } from "./Number-select.vue?vue&type=template&id=20252ecc&scoped=true"
import script from "./Number-select.vue?vue&type=script&lang=js"
export * from "./Number-select.vue?vue&type=script&lang=js"

import "./Number-select.vue?vue&type=style&index=0&id=20252ecc&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20252ecc"]])

export default __exports__